import React from "react";
import Modal from "./Model";

const AttributeInput = ({ attribute, selectedValues, onSave, handleInputChange }) => {
    const handleInputChangeWrapper = (key, value) => handleInputChange(key, value);
    switch (attribute?.inputType) {
        case 'MultipleSelect':

            return (
                <Modal
                    size="sm"
                    attribute={attribute?.key}
                    attributeName={attribute?.name}
                    attributeValues={attribute?.children}
                    selectedValues={selectedValues[attribute?.id] || []}
                    onSave={onSave}
                    handleInputChange={handleInputChange}
                />
            );
        case 'TextField':
          return (
        <input
            type="text"
          className="form-control form-control-sm w-100 border border-dark"
          placeholder={`Enter ${attribute?.name}` || "Enter value"}
            name={attribute.id}
            value={
                selectedValues[attribute.id]?.attributeValue?.[0]?.value || ""
            }
            onChange={(e) =>
                handleInputChangeWrapper(attribute.id, {
                    attribute_id: attribute.id,
                    attributeValue: [
                        {
                            id: null,
                            value: e.target.value,
                        },
                    ],
                })
            }
        />
    );
        case 'Date':
            return (
                <input
                    type="date"
                    className="form-control form-control-sm"
                    value={selectedValues}
                    onChange={(e) => handleInputChangeWrapper(attribute.id, e.target.value)}
                />
            );
        case 'CheckBox':
            return (
                <div>
                    {attribute?.children?.map((option) => (
                        <label key={option.value} className="mr-3">
                            <input
                                className="mr-2"
                                type="checkbox"
                                value={option.value}
                                checked={selectedValues.includes(option.value)}
                            />
                            {option.value}
                        </label>
                    ))}
                </div>
            );
        case 'radio':
            return (
                <div>
                    {attribute?.children?.map((option) => (
                        <label key={option.value} className="mr-3">
                            <input
                                type="radio"
                                name={attribute?.key}
                                value={option?.value}
                                checked={selectedValues === option?.value}
                                onChange={() => handleInputChangeWrapper(attribute?.id, option?.value)}
                            />
                            {option.label}
                        </label>
                    ))}
                </div>
            );
        case 'Dropdown':
            return (
                <select
                    className="form-control form-control-sm"
                    name={selectedValues[attribute.id]}
                    value={selectedValues[attribute.id] || ""}
                    onChange={(e) => handleInputChangeWrapper(attribute.id, [e.target.value])}
                >

                    <option value="" disabled>
                        Select  {attribute?.name}
                    </option>

                    {attribute?.children?.map((option) => (
                        <option key={option?.id} value={option?.id}>
                            {option?.name}
                        </option>
                    ))}
                </select>
            );
        default:
            return null;
    }
};

export { AttributeInput };



